import './style.scss';
import { DocumentHeader } from './module/documentHeader';
import { IssuanceDocumentFileList } from './module/documentList';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { LoadingContainer, LoadingSize } from 'views/mutual/loading';
import { IssuanceDocumentFileListProps, useIssuanceDocumentFileList } from './hooks';
import { Pagination } from 'views/mutual/pagination';
import { SearchBox } from 'views/mutual/searchBox';
import { ComponentControl } from 'views/mutual/componentControl';
import { IssuanceDocumentNote } from './module/note';

export const IssuanceDocumentFileListPage = (props: IssuanceDocumentFileListProps) => {
  const {
    documentFileList,
    searchKeyWord,
    setSearchKeyWord,
    submitKeyWord,
    currentPage,
    setCurrentPage,
    perPageCount,
    selectedItems,
    onSelect,
    handleMultiDownload,
    download,
  } = useIssuanceDocumentFileList(props);

  if (documentFileList.fetching && !documentFileList.data) {
    return (
      <LoadingContainer isLoading={documentFileList.fetching} size={LoadingSize.Medium}>
        <div></div>
      </LoadingContainer>
    );
  }

  return (
    <>
      <div className="documentSearch">
        <div className="documentSearch_searchBoxWrapper">
          <SearchBox
            searchWord={searchKeyWord}
            setSearchWord={setSearchKeyWord}
            submitSearch={(searchWord) => {
              submitKeyWord(searchWord);
            }}
            clearSearch={() => {
              submitKeyWord('');
            }}
            placeholder="キーワードで書面を検索"
          />
        </div>
      </div>
      <div className="documentList">
        <div className="documentList_wrapper">
          <DocumentHeader />
          <LoadingContainer isLoading={documentFileList.fetching} size={LoadingSize.Small}>
            <ComponentControl
              componentName={IssuanceDocumentFileList}
              noDataMessege="書面はありません"
              isLoading={documentFileList.fetching}
              items={documentFileList.data?.GetIssuanceDocumentFileList?.Data || []}
              selectedItems={selectedItems}
              onSelect={onSelect}
              download={download}
            />
          </LoadingContainer>
        </div>
        <IssuanceDocumentNote folderId={props.folderId}/>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          fetchApi={() => {}}
          totalCount={documentFileList.data?.GetIssuanceDocumentFileList?.TotalCount || 0}
          perPageCount={perPageCount}
        />
        <Button
          label="選択した書類をダウンロード"
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          onClick={handleMultiDownload}
        />
      </div>
    </>
  );
};
